export const NONE = 'none'
export const ONLY_ME = 'only-me'
export const ALL = 'all'
